export default "__VITE_ASSET__CNmu2VjO__"